import Repository from './repository';

const resource = '/public';
export default {
	login(payload) {
		return Repository.post(
			`${resource}/genericlogin`,
			payload,
			{},
			{ noCache: true }
		);
	},
	forgotpass(payload) {
		return Repository.post(`${resource}/forgotpassword`, payload);
	},

	// Applies an email change from the token in the verification link. Public: the
	// person following the link may not be signed in, or may be signed in elsewhere.
	confirmEmailChange(payload) {
		return Repository.post(`${resource}/emailchange/confirm`, payload);
	},

	failedLoginAttempts(payload) {
		return Repository.post(`${resource}/failedloginattempts/reset `, payload);
	},

	twoFALogin(payload) {
		return Repository.post(`${resource}/twoFALogin`, payload);
	},

	resendTwoFaOTP(payload) {
		return Repository.post(`${resource}/resendOtp`, payload);
	},

	sendCodeToAlternativeChannel(payload) {
		return Repository.post(`${resource}/sendOtpToAlternative`, payload);
	},
};
